<template><div><h1 id="gutschein" tabindex="-1"><a class="header-anchor" href="#gutschein"><span>Gutschein</span></a></h1>
<p>Gutschein — Verwaltung von Gutscheinen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Verwaltung der sich im Umlauf befindlichen Gutscheine. Das Programm ermöglicht das Erfassen von gültigen Gutscheinen, den Verkauf an einen bestimmten Kunden sowie das Einlösen (an Zahlung nehmen) des Gutscheins von einem bestimmten Kunden. Massgebend ist, welche Adresse aktuell im Adressenstamm angezeigt wird. Hierbei handelt es sich um einen reinen Anzeigeframe.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Gutscheintypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Typ</dt>
<dd>Gutscheintyp, Auswahl aus Tabelle <a class="link" href="ft.refdata.tblgbontyp.html" title="Gutscheintypen">Gutscheintypen</a></dd>
<dt>Gutscheinnummer</dt>
<dd>Gutscheinnummer, dient der eindeutigen Identifikation jedes Gutscheins, wird vom System automatisch vergeben und muss mit der Numerierung auf dem Gutschein übereinstimmen.</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Ohne Laufnummer-Eintrag in der Tabelle <a class="link" href="ft.refdata.tblgbontyp.html" title="Gutscheintypen">Gutscheintypen</a> ist dieser Eintrag leer (&quot;?&quot;) und ein Verkauf nicht möglich! Die Gutscheine können aber problemlos angenommen werden.</p>
</div>
<dl>
<dt>Wert</dt>
<dd>Betrag in Franken, abhängig vom Gutscheintyp (Anzeige)</dd>
<dt>Fakturanummer</dt>
<dd>Fakturanummer, mit welcher der Gutschein dem Kunden in Rechnung gestellt wurde</dd>
<dt>verkauft an</dt>
<dd>Personen-ID des Käufers, desjenigen Kunden, der den Gutschein gekauft hat</dd>
<dt>Ausgabedatum</dt>
<dd>Verkaufsdatum</dd>
<dt>eingelöst von</dt>
<dd>Personen-ID des Nutzers, desjenigen Kunden, der den Gutschein eingelöst hat.</dd>
<dt>Einlösedatum</dt>
<dd>Datum der Annahme des Gutscheins, wann der Gutschein eingelöst wurde</dd>
<dt>S</dt>
<dd>Status des Gutscheins:<br>1 = erfasst, noch nicht fakturiert<br>I = fakturiert, noch nicht eingelöst<br>B = eingelöst</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Gutschein verkaufen</dt>
<dd>Verkauf eines Gutscheins. Erfassen des Verkaufs eines Geschenkbons. Das Vorhandensein eines Bons wird beim Debitor als obligatorische Debitorennote erfasst; wird ein Bon zurückgenommen bzw. vom Kunden an Zahlung gegeben, werden Erlösminderungen ausgelöst.</dd>
<dt>Gutschein annehmen</dt>
<dd>Gutschein zur Zahlung annehmen. Es erscheint ein Fenster, in dem die Nummmer eingetragen werden kann. In die Spalte &quot;Nutzer&quot; wird die Personen-ID der aktuell angezeigten Adresse übernommen</dd>
<dt>Gutschein freigeben</dt>
<dd>Reaktivierung eines irrtümlich angenommenen Gutscheins. Die Manipulationen im System bleiben in den Einzelbuchungen erhalten und können dadurch nachvollzogen werden (Erlösminderungen und Storno Erlösminderungen)</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Das System lässt auch zu, dass bereits in der Fakturierung verwendete Gutscheine freigegeben werden können. Dies bewirkt eine Veränderung des Debitorensaldos gegenüber der ausgedruckten Rechnung und ist entsprechend manuell zu korrigieren</p>
</div>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


